import { createPortal } from "react-dom";
import { createRoot } from "react-dom/client";
import useContentful from "./hooks/useContentful";
import getContentfulLocale from "./lib/getContentfulLocale";
import { ContentfulNavigationItem } from "./lib/contentfulTypes";
import MobileMenu from "./components/MobileMenu";
import BurgerButton from "./components/BurgerButton";
import { useEffect, useState } from "react";
import DesktopMenu from "./components/DesktopMenu";

const targetElementId = 'contentful-header-render-target';

const ContentfulHeader = () => {
  const renderTarget = document.getElementById(targetElementId);
  if (!renderTarget) return null;

  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  const entryId = renderTarget?.dataset.entryId;
  let localeString = renderTarget?.dataset.shopLocale;
  let localeMarket = renderTarget?.dataset.shopMarket;
  const locale = getContentfulLocale(localeString, localeMarket);
  
  const brandDiv = document.getElementById('site-brand-setting');
  const brand = brandDiv?.dataset?.brand || 'fender';

  const {contentfulData} = useContentful({'sys.id': entryId, locale, include: 10});
  const menuItems = (contentfulData) 
    ? contentfulData?.items[0]?.fields?.navigation as ContentfulNavigationItem[] 
    : [];

  let supportNav: ContentfulNavigationItem[] = [];
  if (brand == 'fender' && contentfulData) {
    supportNav = contentfulData?.items[0]?.fields?.supportNavigation as ContentfulNavigationItem[] || [];
  }

  const mobileMenuTarget = document.getElementById('contentful-mobile-menu-render-target');
  const burgerTarget = document.getElementById('contentful-hamburger-button-target');
  const desktopMenuTarget = document.getElementById('contentful-desktop-menu-target');
  const logoUrl = mobileMenuTarget?.dataset.logoUrl;

  const openMobileMenu = () => {
    setMobileMenuIsOpen(true);
    document.documentElement.style.overflow = 'hidden';
  }

  const closeMobileMenu = () => {
    setMobileMenuIsOpen(false);
    document.documentElement.style.overflow = 'initial';
  }

  const handleResize = () => {
    if (window.innerWidth >= 1150 && mobileMenuIsOpen) {
      closeMobileMenu();
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize); }
  });

  return (
    <>
      {menuItems.length > 0 && mobileMenuTarget && createPortal(
        <MobileMenu 
          brand={brand}
          isOpen={mobileMenuIsOpen}
          items={menuItems}
          logoUrl={logoUrl}
          onClose={closeMobileMenu}
          supportNav={supportNav}
        />,
        mobileMenuTarget
      )}
      {burgerTarget && createPortal(
        <BurgerButton 
          // Todo: Fender has a transparent menu option, which will need to be considered here.
          fill={(brand == 'jackson') ? '#fff' : '#000'}
          onClick={openMobileMenu} 
        />,
        burgerTarget
      )}
      {menuItems.length > 0 && desktopMenuTarget && createPortal(
        <DesktopMenu brand={brand} items={menuItems} supportNav={supportNav} />,
        desktopMenuTarget
      )}
    </>
  );
}

createRoot(document.getElementById(targetElementId) as HTMLElement).render(<ContentfulHeader />);